var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.props.loadedData
    ? _c("div", { class: ["widget-base-component", _vm.customClass] }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "resize",
                rawName: "v-resize",
                value: _setup.calculateMainHeight,
                expression: "calculateMainHeight",
              },
            ],
            staticClass: "main-section",
          },
          [
            _vm.showHeader ? _c("header", [_vm._t("header")], 2) : _vm._e(),
            _c("main", [_vm._t("body")], 2),
          ]
        ),
        _vm.showFooter ? _c("footer", [_vm._t("footer")], 2) : _vm._e(),
      ])
    : _c(_setup.SpinnerLayerComponent, { staticClass: "spinner-layer" })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }